import axios from 'axios';
import { normalizeError } from 'utils/logError';
import {
    SecurityTypes
} from 'actions/types';

export function setCodeChallenge(code) {
    return {
        type: SecurityTypes.SET_CODE_CHALLENGE,
        payload: {
            codeChallenge: code
        }
    }
}

export function fetchVerifyToken() {
    return (dispatch, getState) => {
        let headers, method, params, url;
        try {
            const domains = getState().urls.get('domains');
            headers = getState().config.get('headers').toJSON();
            const currentDomainIndex = getState().config.get('currentDomainIndex');
            const route = getState().urls.get('verify');
            const operatorId = getState().config.get('operatorId');
            const token = getState().security.get('accessToken');
            const codeChallenge = getState().security.get('codeChallenge');
            method = route.get('method');
            params = {
                token: token,
                appId: operatorId,
                code_challenge: codeChallenge,
            }
            url = `${domains.get(currentDomainIndex)}${route.get('href')}`;
        } catch (error) {
            dispatch(tokenRejected(error))
            throw error;
        }

        dispatch({
            type: SecurityTypes.FETCH_VERIFY_TOKEN,
            payload: {
                method: method,
                url: url,
                params: params
            }
        })

        return axios({ method, url, headers, data: params })
        .then( ({ data }) => {
            dispatch({
                type: SecurityTypes.TOKEN_VERIFIED,
                payload: data
            });
            return data;
        })
        .catch( error => {
            const normalized = normalizeError(error)
            dispatch(tokenRejected(normalized));
            throw normalized
        })
    }
}

export function tokenRejected(error) {
    return {
        type: SecurityTypes.TOKEN_REJECTED,
        payload: error
    }
}